import React from 'react';
import { AiOutlineMenuUnfold } from 'react-icons/ai';
import adminpic from '../../images/adminpic.jpg';
import { MdMoveToInbox, MdGTranslate, MdTableRows } from 'react-icons/md';
import { CgMenuGridR } from 'react-icons/cg';
import { SlCalender } from 'react-icons/sl';
import { Button, Layout, Dropdown, Space, theme } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './HeaderComponent.css';
import { CgProfile } from 'react-icons/cg';
import admin from '../../images/admin.png';
import LogoutButton from '../LogoutButton'

const Headercomponent = () => {
  const { Header } = Layout;
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const items = [
    {
      key: '1',
      label: <a href="https://www.antgroup.com">Administrator</a>,
    },
    {
      key: '2',
      label: <a href="https://www.aliyun.com">Home</a>,
    },
    {
      key: '3',
      label: <LogoutButton />,
    },
  ];
  return (
    <Header className=" bg-white header-container ">
      <div className="header-content">
        <div className="icon-buttons">
          <button className="icon-button">
            <MdGTranslate />
          </button>
          <button className="icon-button">
            <CgMenuGridR />
          </button>
          <button className="icon-button">
            <AiOutlineMenuUnfold />
          </button>
          <button className="icon-button">
            <SlCalender />
          </button>
          <button className="icon-button">
            <MdTableRows />
          </button>
        </div>
        <Dropdown menu={{ items }}>
          <a onClick={e => e.preventDefault()} className="admin-dropdown">
            <Space>
              <div className="admin-info">
                <img className="w-5 h-5" src={admin}></img>

                <h4 className="admin-name">Administrator</h4>
              </div>
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      </div>
    </Header>
  );
};

export default Headercomponent;
